import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddGoals = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/goal`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onUpdateGoal = async (GoalID:number, postData: any, config: any) => {
  try {
    const response = await axios.patch(`${baseURL}/goal/${GoalID}`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetOrgGoals = async (id: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/goal/organization/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetTemplateGoals = async (templateID: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/goal/template/${templateID}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetEmployeeGoals = async (employeeID: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/goal/employee/${employeeID}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

export { onAddGoals,onUpdateGoal, onGetTemplateGoals,onGetEmployeeGoals, onGetOrgGoals };
